/* eslint-disable */
import "@babel/polyfill";
import "./assets/stylus/main.styl";
import * as VueGoogleMaps from "vue2-google-maps";

import Vue from "vue";
import "./plugins/vuetify";
import VeeValidate from "vee-validate";
import App from "./App.vue";
import router from "./router";
import store from "./store";
window.axios = require("axios");
import authService from "./services/auth-service";
window.axios.defaults.headers.common["content-type"] = "application/json";
axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("token");
Vue.use(VeeValidate);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDmGgu_5k-fvtbMYrToru1CELjdgcVVtRU",
    libraries: "places" // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }
});

let isRefreshing = false;
let refreshSubscribers = [];
window.axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const {
      config,
      response: { status },
      headers
    } = error;
    const originalRequest = config;
    if (status === 401 && error.response.headers.hasOwnProperty("token-expired")) {
      if (!isRefreshing) {
        isRefreshing = true;

        authService.refreshAccessToken().then(response => {
          isRefreshing = false;
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("refreshToken", response.data.refreshToken);
          onRrefreshed(response.data.token);
        });
      }

      const retryOrigReq = new Promise((resolve, reject) => {
        subscribeTokenRefresh(token => {
          // replace the expired token and retry
          originalRequest.headers["Authorization"] = "Bearer " + token;
          resolve(axios(originalRequest));
        });
      });
      return retryOrigReq;
    } else {
      return Promise.reject(error);
    }
  }
);

function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb);
}

function onRrefreshed(token) {
  refreshSubscribers.map(cb => cb(token));
  refreshSubscribers = [];
}

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
